import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { useLocalStorageCache } from 'edcom-ui';

const initialValue = {
  loading: true,
  inGdpr: null,
  gdprCookieDisabled: null,
};

const errorValue = {
  loading: false,
  inGdpr: false,
  gdprCookieDisabled: false,
};

const GDPRContext = createContext(initialValue);

const GDPRProvider = ({ children }) => {
  // Get GDPR status from API on initial page load
  const gdpr = useLocalStorageCache('gdpr_v2', initialValue, async () => {
    // TODO: don't rely on PHP slim api, use a microservice instead
    const response = await fetch('/api/member/status_info', {
      mode: 'cors',
      cache: 'default',
      credentials: 'same-origin',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query_string: {}, url: '/', csrfToken: '' }),
    });

    // If api call failed, assume not in GDPR
    if (!response.ok) {
      return errorValue;
    }

    // If json is badly formed, assume not in GDPR
    const json = await response.json();
    if (!json || !json.status || !json.result) {
      return errorValue;
    }

    return {
      loading: false,
      inGdpr: !!json.result.inGDPRCountry,
      gdprCookieDisabled: !!json.result.gdprCookieDisabled,
    };
  });

  return <GDPRContext.Provider value={gdpr}>{children}</GDPRContext.Provider>;
};

GDPRProvider.displayName = 'GDPRProvider';
GDPRProvider.propTypes = {
  children: PropTypes.node,
};

export { GDPRContext as default, GDPRProvider };
